export class Package{
    id: string;
    packageName: string;
    price: number;
    status: string;
}
